// extracted by mini-css-extract-plugin
export default {"link":"LyA0m","link--disabled":"Q3y2J","link--small":"Ngrtf","link--muted":"YVdnl"};